import { render, staticRenderFns } from "./SpcmStudentMilestone.vue?vue&type=template&id=07d76092&lang=true"
import script from "./SpcmStudentMilestone.vue?vue&type=script&lang=js"
export * from "./SpcmStudentMilestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports